import React from 'react';
import Modal from 'components/UI/Modal';
import { alert } from 'util/alert';
import "./Modal.scss";
import ModalContent from "./ModalContent";
import { confirmable } from 'react-confirm';
import updateTradeNote from 'controllers/school/updateTradeNote'
import updateStudentInfo from 'controllers/student/updateStudentInfo'
import editClient from 'controllers/client/editClient'

class ModalBody extends React.Component {

  constructor(props){
    super(props)
  }

  onSubmitAction(){
    let {
      dismiss,
      id,
      type,
      proceed
    } = this.props;

    if(type == 'finance'){
      if(this.formData){
        updateTradeNote(id, this.formData)
        .then((res) => {proceed()})
      } else {
        dismiss()
      }
    } else if (type == 'student'){
      if(this.formData){
        updateStudentInfo(id, this.formData)
        .then((res) => {dismiss()})
      } else{
        dismiss()
      }
    } else if (type == 'client'){
      if(this.formData){
        editClient(id, this.formData)
        .then((res) => {dismiss()})
      } else {
        dismiss()
      }
    }
  }

	render() {
		let {
      show,
      proceed,
      dismiss,
      cancel,
      id,
      type
    } = this.props;

		return (
			<Modal
				className='remarks-modal'
				hasHeader={true}
        hasFooter={true}
				headerTitle={__("Remarks", "finance")}
				headerIcon="fa icon-clipboard-check"
        fixedWidth={500}
        contentHeight={300}
        onCloseModalClick={dismiss}
        footerType="grey"
        footerButtons={[
          {
            title: __('Complete', 'appwrapper'),
            className: 'btn btn-primary pull-right',
            onClick: ()=>{
              this.onSubmitAction()
            }
          },
          {
            title: __('Cancel', 'changeschool'),
            className: 'btn btn-default pull-right',
            onClick: ()=>{
              dismiss()
            }
          }
        ]}
        isShowingModal={show} >
        <ModalContent
          {...this.props}
          onFormChange={(stateFromModalContent)=>{ this.formData = stateFromModalContent; }}
         />
			</Modal>
    );
  }
}

export default confirmable(ModalBody);



// WEBPACK FOOTER //
// ./src/template/Modals/Remarks/ModalBody.js